/**
 * Created by tmorone on 2/11/2016.
 */

var Marionette = require('backbone.marionette');

module.exports = Marionette.LayoutView.extend({
    template: require('../templates/Footer.html')
});
